import React, { useEffect, useRef, useState } from "react";
import passwordEyeIconOn from "../../../assets/images/LoginIcons/eyeIconOn.svg";
import passwordEyeIconOff from "../../../assets/images/LoginIcons/eyeIconOff.svg";
import { useController, useFieldArray, useFormContext } from "react-hook-form";
import searchIcon from "../../../assets/images/Common/magnifyingGlass.png";
import CrossIcon from "../SvgIcons/SocialIcons/CrossIcon";
import PlusIcon from "../SvgIcons/CommonIcons/PlusIcon";
import Button from "../Button/Button";
import classes from "./Input.module.scss";
import useComponentVisible from "../../../hooks/useComponentVisible";
import { useCallback } from "react";
import { useCheckList } from "../../../hooks/useCheckList";
import ViewIcon from "../SvgIcons/TableIcons/ViewIcon";
import Loader from "../Loader/Loader";
import Tooltip from "../ToolTip/Tooltip";
import { useSelector } from "react-redux";
import { MdCancel } from "react-icons/md";
import { IoMdArrowDropdown } from "react-icons/io";
import { FormattedMessage } from "react-intl";

const TagInputListItem = ({
  isNested = false,
  nestFieldName,
  fieldValue,
  fieldName,
  tag,
  tagType,
  handleCheckOne,
  handleAddTag,
  handleRemoveTag,
  tagsFields,
  setTagListVisible,
  handleClickTag = false,
  isTagCheckBoxVisible = true,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  useEffect(() => {
    if (tagType === "single") {
      let selected = false;
      tagsFields?.forEach((selectedTag) => {
        if (selectedTag[fieldValue] === tag[fieldValue]) {
          selected = true;
        }
      });
      setIsSelected(selected);
    }
  }, [fieldValue, tag, tagType, tagsFields]);

  return (
    <li
      className={
        classes.input__fieldBox__inputContainer__field__tagSearchList__listSelectItem
      }
    >
      <div
        className={
          isSelected
            ? classes.input__fieldBox__inputContainer__field__tagSearchList__listSelectItem__textContainerSelected
            : classes.input__fieldBox__inputContainer__field__tagSearchList__listSelectItem__textContainer
        }
        onClick={(e) => {
          if (!tag?.disabled) {
            e.stopPropagation();
            if (tagType === "single") {
              setTagListVisible(false);
            }
            if (handleClickTag) {
              handleClickTag(tag);
            } else {
              if (tagType !== "single") {
                handleCheckOne(fieldValue ? tag[fieldValue] : tag);
              }
              if (tag?.checked) {
                handleRemoveTag(
                  tagsFields.findIndex(
                    (tagF) => tag[fieldValue] === tagF?.[fieldValue]
                  ),
                  tag
                );
              } else {
                handleAddTag(
                  fieldName ? tag[fieldName] : tag,
                  fieldValue ? tag[fieldValue] : tag
                );
              }
            }
          }
        }}
      >
        {isNested && (
          <span
            onClick={(e) => {
              e.stopPropagation();
              setIsExpanded(!isExpanded);
            }}
            style={{
              visibility:
                tag?.[nestFieldName]?.length > 0 ? "visible" : "hidden",
            }}
            className={isExpanded ? classes.caretDown : classes.caret}
          >
            {" "}
          </span>
        )}
        {isTagCheckBoxVisible && (
          <input
            type={"checkbox"}
            checked={tag?.checked}
            height="2"
            width="2"
            // onChange={() => {}}
            readOnly
            disabled={tag?.disabled}
          />
        )}
        {fieldName ? tag[fieldName] : tag}
      </div>
      <ul
        className={
          classes.input__fieldBox__inputContainer__field__tagSearchList2
        }
      >
        {isNested &&
          isExpanded &&
          tag?.[nestFieldName]?.map((tag, index) => {
            return (
              <TagInputListItem
                key={index}
                isNested={isNested}
                nestFieldName={nestFieldName}
                fieldValue={fieldValue}
                fieldName={fieldName}
                tag={tag}
                handleCheckOne={handleCheckOne}
                handleAddTag={handleAddTag}
                handleRemoveTag={handleRemoveTag}
                tagsFields={tagsFields}
              />
            );
          })}
      </ul>
    </li>
  );
};

const TagInputList = ({
  width,
  widthType,
  height,
  borderRadius,
  valueArr,
  searchTagsList,
  name,
  type,
  fieldName,
  buttonLabel,
  subButtonLabel,
  subButtonIcon,
  handleSubButton,
  fieldValue,
  validations,
  isValidTagSearch = true,
  placeholder,
  onChange,
  handleTagList = () => {},
  error,
  loading,
  tagType = "multi",
  addedTagsVisible = true,
  isNested = false,
  nestFieldName,
  isTagCheckBoxVisible,
  handleClickTag,
  searchable = false,
  ...rest
}) => {
  const { register, control, setValue } = useFormContext({});
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const {
    fields: tagsFields,
    append: appendTag,
    remove: removeTag,
    update: updateTag,
  } = useFieldArray({
    control,
    name: name || "TagsList",
  });

  const { field } = useController({ name: `TagSearch-${name}`, control });

  const [tagListRef, isTagListVisible, setTagListVisible] =
    useComponentVisible();

  const { handleCheckOne } = useCheckList(
    fieldValue,
    searchTagsList,
    handleTagList,
    () => {},
    isNested,
    nestFieldName
  );

  useEffect(() => {
    if (type === "tags") {
      searchTagsList?.length > 0 && field?.value?.length > 0
        ? setTagListVisible(true)
        : setTagListVisible(false);
    }
    // else if (tagType !== "multi" && field?.value?.length === 0) {
    //   setTagListVisible(false);
    // }
  }, [type, searchTagsList, setTagListVisible, field?.value]);

  // useEffect(() => {
  //   if (type === "noSearchTags") {
  //     if (field?.value?.length > 0) {
  //       setTagListVisible(true);
  //     } else {
  //       setTagListVisible(false);
  //     }
  //   }
  // }, [type, setTagListVisible, field?.value]);

  const handleAddTag = useCallback(
    (val1, val2) => {
      let isValueExists = false;
      tagsFields.forEach((field) => {
        if (type === "noSearchTags") {
          if (field?.[fieldName] === val1 && field?.[fieldValue] === val2) {
            isValueExists = true;
          }
        } else if (field?.[fieldName] === val1) {
          isValueExists = true;
        }
      });
      if (val1 && val1?.trim(" ") !== "" && !isValueExists) {
        if (tagType === "single") {
          if (type === "noSearchTags") {
            setValue(`TagSearch-${name}`, "");
            const updatedList = searchTagsList?.map((tagItem) => {
              return { ...tagItem, isVisible: true };
            });
            handleTagList(updatedList);
          }
          updateTag(0, { [fieldName]: val1, [fieldValue]: val2 });
          if (onChange) {
            onChange({ target: { value: "" } });
          }
        } else {
          appendTag({ [fieldName]: val1, [fieldValue]: val2 });
        }
        if (type === "tags") {
          if (tagType === "single") {
            setTagListVisible(false);
          }
          setValue(`TagSearch-${name}`, "");
        }
      }
    },
    [
      name,
      onChange,
      type,
      fieldName,
      fieldValue,
      searchTagsList,
      setTagListVisible,
      handleTagList,
      tagsFields,
      appendTag,
      setValue,
      tagType,
      updateTag,
    ]
  );

  const handleRemoveTag = (index, tag) => {
    if (!rest?.disabled) {
      removeTag(index);
      if (tag) {
        handleCheckOne(fieldValue ? tag[fieldValue] : tag);
      }
    }
  };
  const handleTagSearchList = () => {
    const updatedList = searchTagsList?.map((tagItem) => {
      return { ...tagItem, isVisible: true };
    });
    handleTagList(updatedList);
  };
  return (
    <div
      className={classes.input__fieldBox__inputContainer__field}
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        width: width + widthType,
        minHeight: height + "rem",
        gap: "1rem",
        borderRadius: borderRadius + "rem",
        padding:
          tagType === "single"
            ? "1.3% 2%"
            : type === "tags"
            ? "2% 10% 2% 2%"
            : "2%",
        backgroundColor: "#fff",
      }}
    >
      {addedTagsVisible &&
        tagsFields?.map((tag, index) => {
          return (
            <div
              className={classes.input__fieldBox__inputContainer__field__tag}
              key={tag.id}
            >
              {tag?.[fieldName]
                ? tag?.[fieldName]
                : searchTagsList?.find(
                    (tagVal) => tagVal?.[fieldValue] === tag?.[fieldValue]
                  )?.[fieldName]}
              {!tag?.disabled && (
                <span
                  className={
                    classes.input__fieldBox__inputContainer__field__tag__icon
                  }
                  onClick={() =>
                    handleRemoveTag(
                      index,
                      searchTagsList?.find(
                        (tagVal) => tagVal?.[fieldValue] === tag?.[fieldValue]
                      )
                    )
                  }
                >
                  <MdCancel />
                  {/* <CloseIcon fill={colors.theme} /> */}
                </span>
              )}
            </div>
          );
        })}
      {type !== "noSearchTags" ? (
        <input
          type="text"
          name={`TagSearch-${name}`}
          className={classes.input__fieldBox__inputContainer__field__tagField}
          id={name || fieldName || `TagSearch-${name}`}
          {...register(`TagSearch-${name}`, {
            ...validations,
            onChange: (e) => onChange(e),
          })}
          aria-invalid={error ? "true" : "false"}
          placeholder={placeholder}
          {...rest}
          onKeyDown={(e) => {
            if (e.key === "Enter" && isValidTagSearch) {
              e.preventDefault();
              if (tagType === "multi") {
                handleAddTag(field?.value);
              }
            } else if (e.target.value.length === 0 && e.key === "Backspace") {
              removeTag(tagsFields.length - 1);
            }
          }}
        />
      ) : (
        // !rest?.disabled && (
        <Button
          label={
            tagType === "single" && tagsFields?.length > 0 && !addedTagsVisible
              ? tagsFields[0][fieldName] ||
                buttonLabel || <FormattedMessage id="USERMANAGE_ROLESELECT" />
              : buttonLabel || <FormattedMessage id="USERMANAGE_ROLESELECT" />
          }
          light={tagType === "single"}
          dark={tagType === "multi"}
          borderColor={tagType === "single" ? "transparent" : undefined}
          justifyContent={tagType === "single" ? "space-between" : undefined}
          flexDirection={tagType === "single" ? "row-reverse" : undefined}
          borderSize={tagType === "single" ? "0" : undefined}
          icon={tagType === "single" ? IoMdArrowDropdown : undefined}
          color={tagType === "single" ? "#000" : undefined}
          fontWeight={tagType === "single" ? "500" : undefined}
          height={height}
          width={width}
          onClick={(e) => {
            e.stopPropagation();
            setValue(`TagSearch-${name}`, "");
            handleTagSearchList();
            setTagListVisible(!isTagListVisible);
          }}
          disabled={rest?.disabled}
        />
        // )
      )}
      {type !== "noSearchTags" && tagType === "multi" && (
        <span
          className={classes.input__fieldBox__inputContainer__field__addIcon}
          onClick={() => {
            if (isValidTagSearch) {
              handleAddTag(field?.value);
            }
          }}
        >
          <PlusIcon fill={colors.theme} />
        </span>
      )}
      {isTagListVisible && !rest?.disabled && !loading && isValidTagSearch && (
        <div
          ref={tagListRef}
          className={
            classes.input__fieldBox__inputContainer__field__tagSearchListContainer
          }
        >
          {searchable || subButtonLabel ? (
            <div
              className={
                classes.input__fieldBox__inputContainer__field__tagSearchListContainer__searchField
              }
            >
              {searchable && (
                <input
                  type="text"
                  name={`TagSearch-${name}`}
                  className={
                    classes.input__fieldBox__inputContainer__field__tagField
                  }
                  id={name || fieldName || `TagSearch-${name}`}
                  {...register(`TagSearch-${name}`, {
                    ...validations,
                    onChange: (e) => {
                      let val = e.target.value.trim() !== "" && e.target.value;
                      if (rest?.onInputChange) rest?.onInputChange(val);
                      else {
                        if (val) {
                          const updatedTagsList = searchTagsList?.map(
                            (arrVal) => {
                              if (
                                arrVal?.[fieldName]
                                  ?.toLowerCase()
                                  ?.includes(val.toLowerCase())
                              ) {
                                return { ...arrVal, isVisible: true };
                              } else {
                                return { ...arrVal, isVisible: false };
                              }
                            }
                          );
                          handleTagList(updatedTagsList);
                        } else {
                          const updatedTagsList = searchTagsList?.map(
                            (arrVal) => {
                              return { ...arrVal, isVisible: true };
                            }
                          );
                          handleTagList(updatedTagsList);
                        }
                      }
                    },
                  })}
                  aria-invalid={error ? "true" : "false"}
                  placeholder={placeholder}
                  {...rest}
                  // onKeyDown={(e) => {
                  //   if (e.target.value.length === 0) {
                  //     setTagListVisible(true);
                  //   }
                  // }}
                />
              )}
              {subButtonLabel && (
                <Button
                  label={subButtonLabel}
                  height="3"
                  width="15"
                  icon={subButtonIcon}
                  onClick={handleSubButton}
                  light
                  type="button"
                />
              )}
            </div>
          ) : (
            <></>
          )}
          <ul
            className={
              classes.input__fieldBox__inputContainer__field__tagSearchList
            }
            // style={{ overflowY: type === "tags" ? "hidden" : "auto" }}
          >
            {type === "tags"
              ? searchTagsList?.map((tag, index) => {
                  return (
                    <li
                      key={index}
                      className={
                        classes.input__fieldBox__inputContainer__field__tagSearchList__listItem
                      }
                      onClick={() =>
                        handleAddTag(fieldName ? tag[fieldName] : tag)
                      }
                    >
                      {fieldName ? tag[fieldName] : tag}
                    </li>
                  );
                })
              : searchTagsList?.map((tag, index) => {
                  if ((searchable && tag.isVisible) || !searchable) {
                    return (
                      <TagInputListItem
                        key={index}
                        isNested={isNested}
                        nestFieldName={nestFieldName}
                        fieldValue={fieldValue}
                        fieldName={fieldName}
                        tag={tag}
                        tagType={tagType}
                        handleCheckOne={handleCheckOne}
                        handleAddTag={handleAddTag}
                        handleRemoveTag={handleRemoveTag}
                        tagsFields={tagsFields}
                        isTagCheckBoxVisible={isTagCheckBoxVisible}
                        handleClickTag={handleClickTag}
                        setTagListVisible={setTagListVisible}
                      />
                    );
                  } else {
                    return <React.Fragment key={index}></React.Fragment>;
                  }
                })}
          </ul>
        </div>
      )}
    </div>
  );
};

const Input = ({
  type = "text",
  fieldName,
  fieldValue,
  name,
  label,
  buttonLabel = <FormattedMessage id="USERMANAGE_ROLESELECT" />,
  subButtonLabel = false,
  subButtonIcon,
  handleSubButton,
  labelMsg,
  disableLabelClick,
  labelColor = "dark",
  placeholder,
  defaultValue = "",
  valueArr,
  tagType,
  searchTagsList,
  addedTagsVisible,
  isTagCheckBoxVisible,
  isValidTagSearch,
  handleClickTag,
  error,
  errorPosition = "relative",
  required,
  rows = 1,
  cols = 15,
  validations,
  search = false,
  hidden = false,
  autoComplete = "on",
  height = "5",
  width = "32",
  widthType = "rem",
  borderRadius = "0.8",
  direction = "column",
  gap = "1",
  noPasswordIcon = false,
  fileInputButton = true,
  fileInputButtonHeight = "4.9",
  fileInputButtonWidth = "14.5",
  isLight = true,
  reference,
  handleClickFileButton,
  fileInputIcon,
  fileInputName = "",
  handleCancelFileInput = () => {},
  fileInputView = false,
  handleFileInputView,
  fileInputDownload = false,
  handleFileInputDownload,
  minRange = 0,
  maxRange = 100,
  rangeSymbol = "%",
  handleTagList = () => {},
  isNested,
  nestFieldName,
  onChange = () => {},
  onKeyDown = () => {},
  fileInputRef,
  textAreaScrollable,
  loading = false,
  inputStyles,
  ...rest
}) => {
  const fileRef = useRef(null);
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const [showPassword, setShowPassword] = useState(false);
  const { setValue, register, control, getValues } = useFormContext({});
  const { field } = useController({ name, control });
  const handleClickFileInput = () => {
    fileRef.current.click();
  };
  const [buttonTrue, setButtonTrue] = useState(false);
  const handleHeightTextArea = (e) => {
    if (!e?.target?.value) {
      e.target.style.height = height + "rem";
    } else {
      e.target.style.height = e.target.scrollHeight + "px";
    }
  };
  let fullFileName =
    type === "file" && fileInputName
      ? fileInputName
      : field?.value && typeof field?.value === "string"
      ? field?.value
      : field?.value?.[0]?.name;
  let lastIndexVal =
    type === "file" &&
    fullFileName &&
    (fullFileName.lastIndexOf(".") - 1) >>> 0;
  let fileExtension =
    type === "file" &&
    fullFileName &&
    fullFileName.slice(lastIndexVal + 2).slice(0, 4);
  return (
    <div
      className={classes.input}
      style={{
        flexDirection: direction,
        gap: gap + "rem",
        width:
          direction === "row"
            ? "auto"
            : type === "file" && !fullFileName
            ? fileInputButtonWidth + widthType
            : width + widthType,
        justifyContent: direction.includes("reverse") ? "flex-end" : "normal",
      }}
    >
      <div className={classes.input__labelContainer}>
        {label && (
          <label
            className={classes.input__labelContainer__label}
            htmlFor={!disableLabelClick ? name || fieldName : undefined}
            style={{
              color:
                labelColor === "dark"
                  ? "#404040"
                  : labelColor === "light"
                  ? "#707070"
                  : labelColor,
            }}
          >
            {label}&nbsp;
            <span className={classes.input__labelContainer__label__required}>
              {validations?.required?.value || required ? "*" : ""}
            </span>
          </label>
        )}
        {labelMsg && (
          <span className={classes.input__labelContainer__labelMsg}>
            {labelMsg}
          </span>
        )}
      </div>
      <div className={classes.input__fieldBox}>
        <div className={classes.input__fieldBox__inputContainer}>
          {type === "textarea" ? (
            <textarea
              className={classes.input__fieldBox__inputContainer__field}
              placeholder={placeholder}
              name={name}
              {...register(name, {
                ...validations,
                onChange: (e) => {
                  if (!textAreaScrollable) {
                    handleHeightTextArea(e);
                  }
                  onChange(e);
                },
              })}
              onDrop={(e) => {
                e.preventDefault();
              }}
              style={{
                maxWidth: width + widthType,
                minWidth: width + widthType,
                // height: height + "rem",
                minHeight: height + "rem",
                borderRadius: borderRadius + "rem",
                padding: "1.3rem",
                overflow: textAreaScrollable ? "auto" : "hidden",
                // resize: "none",
                ...inputStyles,
              }}
              id={name || fieldName}
              rows={rows}
              cols={cols}
              {...rest}
            ></textarea>
          ) : type === "select" ? (
            <select
              className={classes.input__fieldBox__inputContainer__field}
              name={name}
              {...register(name, {
                ...validations,
                onChange: (e) => {
                  onChange(e);
                },
              })}
              style={{
                width: width + widthType,
                minHeight: height + "rem",
                borderRadius: borderRadius + "rem",
                color: getValues(name) ? "#404040" : "#b9b9b9",
              }}
              id={name || fieldName}
              {...rest}
              defaultValue={defaultValue}
            >
              {!defaultValue && (
                <option
                  value={""}
                  disabled
                  hidden
                  className={
                    classes.input__fieldBox__inputContainer__field__option
                  }
                >
                  {placeholder}
                </option>
              )}
              {valueArr?.map((val) => {
                return (
                  <option
                    key={val[fieldValue || fieldName]}
                    value={val[fieldValue || fieldName]}
                    className={
                      classes.input__fieldBox__inputContainer__field__option
                    }
                  >
                    {val[fieldName]}
                  </option>
                );
              })}
            </select>
          ) : type === "file" ? (
            <input
              className={classes.input__fieldBox__inputContainer__field}
              type={type}
              name={name}
              id={name || fieldName}
              {...register(name, {
                ...validations,
                onChange: (e) => {
                  setValue(name, e.target?.files);
                  onChange(e);
                },
              })}
              onClick={(event) => {
                event.target.value = null;
              }}
              aria-invalid={error ? "true" : "false"}
              placeholder={placeholder}
              style={{
                width: width + widthType,
                minHeight: height + "rem",
                borderRadius: borderRadius + "rem",
                padding: search ? "0.6rem 1rem 0.6rem 5rem" : "1.3rem",
              }}
              hidden={hidden}
              ref={(e) => {
                field.ref(e);
                if (reference) {
                  reference.current = e;
                } else if (fileRef) {
                  fileRef.current = e;
                }
              }}
              {...rest}
            />
          ) : type === "tags" || type === "noSearchTags" ? (
            <TagInputList
              width={width}
              widthType={widthType}
              height={height}
              borderRadius={borderRadius}
              valueArr={valueArr}
              searchTagsList={searchTagsList}
              type={type}
              name={name}
              fieldName={fieldName}
              buttonLabel={buttonLabel}
              subButtonLabel={subButtonLabel}
              subButtonIcon={subButtonIcon}
              handleSubButton={handleSubButton}
              fieldValue={fieldValue}
              validations={validations}
              placeholder={placeholder}
              onChange={onChange}
              handleTagList={handleTagList}
              isNested={isNested}
              nestFieldName={nestFieldName}
              error={error}
              loading={loading}
              tagType={tagType}
              addedTagsVisible={addedTagsVisible}
              isValidTagSearch={isValidTagSearch}
              isTagCheckBoxVisible={isTagCheckBoxVisible}
              handleClickTag={handleClickTag}
              {...rest}
            />
          ) : type === "range" ? (
            <input
              type={type}
              name={name}
              id={name || fieldName}
              {...register(name, {
                ...validations,
                onChange: (e) => {
                  onChange(e);
                },
              })}
              aria-invalid={error ? "true" : "false"}
              min={minRange}
              max={maxRange}
              style={{
                width: width + widthType,
                borderRadius: borderRadius + "rem",
                margin: "0rem 2rem",
              }}
              {...rest}
            />
          ) : (
            <input
              className={classes.input__fieldBox__inputContainer__field}
              type={type === "password" && showPassword ? "text" : type}
              name={name}
              id={name || fieldName}
              autoComplete={autoComplete}
              {...register(name, {
                ...validations,
                onChange: (e) => {
                  // setValue(name, e.target.value);
                  onChange(e);
                },
              })}
              onKeyDown={(e) => {
                if (onKeyDown) {
                  onKeyDown(e);
                }
                //prevent enter to submit
                // if (e.keyCode === 13) {
                //   e.preventDefault();
                // }
              }}
              onDrop={(e) => {
                e.preventDefault();
              }}
              aria-invalid={error ? "true" : "false"}
              placeholder={placeholder}
              hidden={hidden}
              style={{
                width: width + widthType,
                minHeight: height + "rem",
                borderRadius: borderRadius + "rem",
                padding: search ? "0.6rem 1rem 0.6rem 5rem" : "1.3rem",
              }}
              {...rest}
            />
          )}
          {type === "file" &&
          fullFileName &&
          fileInputName !== "false" &&
          !loading ? (
            <div
              className={
                classes.input__fieldBox__inputContainer__fileNameContainer
              }
              title={
                fileInputView &&
                (fullFileName?.startsWith("http") ||
                  fullFileName?.startsWith("blob:"))
                  ? "File"
                  : fullFileName
              }
              style={{
                minHeight: height + "rem",
                flexDirection: fileInputView ? "column" : "row",
              }}
            >
              <div
                className={
                  classes.input__fieldBox__inputContainer__fileNameContainer__fileName
                }
              >
                <div
                  className={
                    classes.input__fieldBox__inputContainer__fileNameContainer__fileName__text
                  }
                >
                  {fileInputView &&
                  (fullFileName?.startsWith("http") ||
                    fullFileName?.startsWith("blob:"))
                    ? "File"
                    : fullFileName?.length > 25
                    ? fullFileName.slice(0, 20) + "..." + fileExtension
                    : fullFileName}
                  {/* {fullFileName?.length > 25
                    ? fullFileName.slice(0, 20) + "..." + fileExtension
                    : fullFileName} */}
                </div>
                <Tooltip content={"Remove"} direction={"bottom"}>
                  <span
                    className={
                      classes.input__fieldBox__inputContainer__fileNameContainer__fileName__icon
                    }
                    onClick={() => {
                      if (!rest?.disabled) {
                        setValue(name, "");
                        handleCancelFileInput();
                      }
                    }}
                  >
                    <CrossIcon fill={colors.theme} />
                  </span>
                </Tooltip>
              </div>
              {(fileInputView || fileInputDownload) && (
                <Button
                  label={
                    fileInputDownload ? (
                      <FormattedMessage id="DOWNLOAD_LBL" />
                    ) : (
                      <FormattedMessage id="VIEW_SHOTCLASS_HOME" />
                    )
                  }
                  height="3"
                  width={fileInputDownload ? "12.5" : "8.3"}
                  isHover
                  icon={({ fill }) => ViewIcon({ fill, small: true })}
                  onClick={() => {
                    if (fileInputDownload) {
                      if (handleFileInputDownload) {
                        handleFileInputDownload();
                      } else {
                        window.open(field?.value?.MediaUri, "_blank");
                      }
                    } else if (handleFileInputView) {
                      handleFileInputView();
                    } else {
                      window
                        .open(
                          field?.value?.MediaUri || fullFileName,
                          "_blank",
                          "width=422, height=586"
                        )
                        // noopener,noreferrer,
                        .moveTo(440, 550);
                    }
                  }}
                  light
                  type="button"
                />
              )}
            </div>
          ) : (
            type === "file" &&
            fileInputButton && (
              // &&hidden
              <Button
                onClick={() => {
                  if (handleClickFileButton) {
                    handleClickFileButton();
                    setButtonTrue(true);
                  } else {
                    setButtonTrue(false);
                    handleClickFileInput();
                  }
                }}
                icon={fileInputIcon}
                label={
                  placeholder || <FormattedMessage id="CREATE_SELECT_CAT" />
                }
                height={fileInputButtonHeight}
                width={fileInputButtonWidth}
                dark={!isLight}
                light={isLight}
                disabled={rest?.disabled}
                // small
                type="button"
                loading={loading}
              />
            )
          )}
          {search && (
            <img
              src={searchIcon}
              alt="search"
              className={classes.input__fieldBox__inputContainer__searchIcon}
            />
          )}
          {type === "password" && !noPasswordIcon && !hidden && (
            <img
              src={showPassword ? passwordEyeIconOn : passwordEyeIconOff}
              onClick={() => setShowPassword(!showPassword)}
              alt="show password"
              className={classes.input__fieldBox__inputContainer__eyeIcon}
            />
          )}
          {(loading && type !== "file") ||
          (loading && type === "file" && !fileInputButton) ? (
            <div className={classes.input__fieldBox__inputContainer__loader}>
              <Loader />
            </div>
          ) : error ? (
            <div
              className={classes.input__fieldBox__inputContainer__error}
              style={{
                position: errorPosition,
                top: errorPosition === "absolute" ? "100%" : undefined,
              }}
            >
              {error}
            </div>
          ) : (
            <></>
          )}
          {type === "range" && (
            <div
              className={classes.input__fieldBox__inputContainer__sliderValue}
              style={{
                left: "-1rem",
              }}
            >
              {minRange}
              {rangeSymbol}
            </div>
          )}
          {type === "range" && (
            <div
              className={classes.input__fieldBox__inputContainer__sliderValue}
              style={{
                left: `${Number(field?.value / 3)}rem`,
                top: "3rem",
              }}
            >
              {field?.value}
              {rangeSymbol}
            </div>
          )}
          {type === "range" && (
            <div
              className={classes.input__fieldBox__inputContainer__sliderValue}
              style={{
                right: "-6.5rem",
              }}
            >
              {maxRange}
              {rangeSymbol}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Input;
